<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Liquidación de recorridos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Liquidación Recorridos</span>
      <span> /</span>
      <span>Liquidación de recorridos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<!-- <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
        <form [formGroup]='formHeader' novalidate>
            <div class="row filtros-body">
                <div class="col" style="max-width: 200px;">
                    <div class="md-form mb-0">
                        <input value="" type="text" id="nroRecorrido" class="form-control"
                            placeholder="Nro de recorrido" required #nroRecorrido formControlName="nroRecorrido"
                            onlyNumbers />
                        <label for="nroRecorrido">Nro de recorrido</label>
                        <div *ngIf="
                            formHeader.get('nroRecorrido').invalid &&
                            (formHeader.get('nroRecorrido').dirty ||
                            formHeader.get('nroRecorrido').touched)
                            ">
                            <mdb-error *ngIf="formHeader.get('nroRecorrido').hasError('required')">
                                Ingrese nro. de recorrido
                            </mdb-error>
                        </div>
                    </div>
                </div>
                <div class="col d-flex" style="max-width: 150px;">
                    <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                        (click)="showModalSeleccionarRecorrido()">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </button>
                    <h6 class="text-info" style="display: contents;" *ngIf="recorridoSeleccionado">
                        {{recorridoSeleccionado.camion_patente}}
                    </h6>
                    <h6 class="text-danger" style="display: contents;"
                        *ngIf="HiddeTable == true && busquedaIniciada && !recorridoSeleccionado">
                        Ingrese recorrido
                    </h6>
                </div>

                <div class="col">
                    <div class="row filtros-body" *ngIf="recorridoSeleccionado">
                        <div class="col dato">
                            <Strong class="title">Fecha</Strong>
                            <span class="value">{{recorridoSeleccionado.fecha | fecha}}</span>
                        </div>
                        <div class="col dato">
                            <Strong class="title">Patente</Strong>
                            <span class="value">{{recorridoSeleccionado.camion_patente}}</span>
                        </div>
                        <div class="col dato">
                            <Strong class="title">Chofer</Strong>
                            <span class="value">{{recorridoSeleccionado.chofer_rut}}</span>
                        </div>
                        <div class="col dato">
                            <Strong class="title">Hora de salida</Strong>
                            <span class="value">{{recorridoSeleccionado.fecha_hora_salida | date:'HH:mm'}}</span>
                        </div>
                        <div class="col dato">
                            <Strong class="title">Monto recorrido</Strong>
                            <span class="value">
                                $ {{recorridoSeleccionado.total_documentos | numerico}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>


    </div>
    <div class="card-footer text-muted filtros-footer justify-content-end" style="border-top: 1px solid #dee2e6">
      <button mdbBtn type="button" color="info" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      <ng-container *ngIf="!operationCompleted">
        <button mdbBtn type="button" color="success" size="sm" mdbWavesEffect (click)="iniciarLiquidacion(1)">
          Iniciar liquidación
        </button>
      </ng-container>
   </div>
</div> -->

<section>
  <!-- BUSQUEDA DE LIQUIDACION -->
  <app-search-recorrido-table (onSelect)="onRecorridoSeleccionado($event)" (onFechaLiquidacion)="onRecibeFecha($event)"
    (onrecorridoIniciado)="onInitRecorrido($event)" (onNotFound)="onNotFoundRecorrido()" (onClean)="limpiarfiltros()">
  </app-search-recorrido-table>
</section>

<div class="card mb-2 wow detalle-cliente" *ngIf="listaRecorridos">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <ng-container *ngIf="!operationCompleted">
              <th scope="col" style="width: 20px; max-width: 30px;">
                <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
              </th>
            </ng-container>
            <th scope="col" class="text-center">Pagado</th>
            <th scope="col">Documento</th>
            <th scope="col">Tipo</th>
            <th scope="col">RUT</th>
            <th scope="col">Cliente</th>
            <th scope="col">Monto</th>
            <th scope="col">Abonado</th>
            <th scope="col">Estado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && listaRecorridos?.length === 0">
            <td colspan="100%" style="text-align: center">
              Recorrido cerrado
            </td>
          </tr>
          <tr *ngFor="let recorrido of listaRecorridos"
            [ngClass]="{
              EstadoDocumento: recorrido.cabecera.montoAbonado > recorrido.cabecera.monto_documento,
              'fila-con-excedente': recorrido.tieneExcedente
            }">
            <ng-container *ngIf="!operationCompleted">
              <td>
                <mdb-checkbox [checked]="recorrido.additionalInfo.checked"
                  (change)='checkDetalle(recorrido.additionalInfo)'></mdb-checkbox>
              </td>
            </ng-container>
            <td class="text-center">
              <i *ngIf="recorrido.cabecera.estado === 1" class="fa fa-check fa-lg green-text"></i>
              <i *ngIf="recorrido.cabecera.estado === 2" class="fa fa-times fa-lg red-text"></i>
            </td>
            <td>{{recorrido.cabecera.folio | numerico}}</td>
            <td>{{recorrido.cabecera.tipoDteNombre}}</td>
            <td>{{recorrido.cabecera.clienteProveedorRutFormato | rut}}</td>
            <td>{{recorrido.cabecera.nombreCliente}}</td>
            <td>{{recorrido.cabecera.monto_documento | numerico}}</td>
            <td>{{recorrido.cabecera.montoAbonado | numerico}}</td>
            <td>
              <mdb-badge *ngIf="recorrido.cabecera.estado === 1" pill="true" success="true">
                {{recorrido.cabecera.estadoDocumento}}</mdb-badge>
              <!--
                                <mdb-badge *ngIf="recorrido.cabecera.estado === 2" pill="true" warning="true">
                                {{recorrido.cabecera.estadoDocumento}}</mdb-badge>
                            -->
              <mdb-badge *ngIf="recorrido.cabecera.estado === 2" pill="true" danger="true">
                {{recorrido.cabecera.estadoDocumento}}
              </mdb-badge>
              <mdb-badge *ngIf="esSobrepagado(recorrido)" pill="true" danger="true">
                Sobrepagado
              </mdb-badge>
            </td>
            <td>
              <button mdbBtn type="button" color="info" mdbWavesEffect class="btn text-center" size="sm"
                (click)="showVerAbonos(recorrido)">
                Ver abonos
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaRecorridos?.length > 0"></app-pagination>
      </table>
    </div>
    <p class="small text-muted mb-2 mt-1" *ngIf="listaRecorridos?.length > 0 && hayDocumentosConExcedente">
      <span class="leyenda-excedente-muestra"></span>
      Documentos con excedente (pago a cuenta).
    </p>
    <p class="small text-muted mb-2 mt-1" *ngIf="listaRecorridos?.length > 0 && hayDocumentosConSobrepago">
      <span class="leyenda-sobrepago-muestra"></span>
      Documentos con sobrepago (abono mayor al monto del documento).
    </p>
    <div>
      <Strong class="title">Totales</Strong>
    </div>
    <div class="row filtros-body" *ngIf="recorridoSeleccionado">
      <div class="dato">
        <Strong class="title">Monto Docs.</Strong>
        <span class="value">$ {{montoDoc | numerico}}</span>
      </div>
      <div class="dato">
        <Strong class="title">Abonos</Strong>
        <span class="value">$ {{ abonos | numerico}}</span>
      </div>
      <div class="dato">
        <Strong class="title">Saldos</Strong>
        <span class="value">$ {{saldos| numerico}}</span>
      </div>
    </div>
  </div>
</div>
<div class="card mb-2 wow detalle-cliente" *ngIf="detallePagos && recorridoSeleccionado">
  <div class="card-body justify-content-between">
    <div class="row filtros-body" *ngIf="detallePagos && recorridoSeleccionado">
      <div class="col dato">
        <Strong class="title">Estado:</Strong>
        <span pill="true" class="value">Liquidado</span>
      </div>
      <div class="col dato" *ngIf="detallePagos != null">
        <Strong class="title">Fecha liquidación</Strong>
        <span class="value">{{detallePagos.fecha_registro | fecha}}</span>
      </div>
      <div class="col ">
        <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm float-right"
          (click)="downloadExcelPdf('PDF', this.recorridoSeleccionado.codigo)">
          PDF
        </button>
      </div>

    </div>
    <!-- <div class="row filtros-body"> -->

    <!-- </div> -->

    <div class="row filtros-body">
      <div class="col dato">
        <Strong class="title">Efectivo</Strong>
        <span class="value">$ {{(detallePagos.efectivo_recaudado != null ? detallePagos.efectivo_recaudado : 0) |
          numerico}}</span>
      </div>
      <div class="col dato">
        <Strong class="title">Transferencia</Strong>
        <span class="value">$ {{(detallePagos.cantidad_transferencias != null ? detallePagos.cantidad_transferencias :0)
          |
          numerico}}</span>
      </div>
      <div class="col dato">
        <Strong class="title">Documentos</Strong>
        <span class="value">$ {{(detallePagos.monto_cheque != null ? detallePagos.monto_cheque :0) | numerico}}</span>
      </div>
      <div class="col dato">
        <Strong class="title">Depositos</Strong>
        <span class="value">$ {{(detallePagos.monto_deposito != null ? detallePagos.monto_deposito :0) |
          numerico}}</span>
      </div>
      <div class="col dato">
        <Strong class="title">Creditos</Strong>
        <span class="value">$ {{(detallePagos.monto_credito != null ? detallePagos.monto_credito :0) | numerico}}</span>
      </div>
      <!-- <div class="col dato">
                <Strong class="title">Notas Creditos</Strong>
                <span class="value">$ {{(detallePagos.monto_nota_credito ? detallePagos.monto_nota_credito :0) | numerico}}</span>
            </div> -->
      <div class="col dato">
        <Strong class="title">Anticipos y NC</Strong>
        <span class="value">
          $ {{(detallePagos.monto_abono != null ? detallePagos.monto_abono :0) | numerico}}
        </span>
      </div>
      <div class="col dato">
        <Strong class="title">Faltantes</Strong>
        <span class="value">
          $ {{(detallePagos.monto_faltante != null ? detallePagos.monto_faltante :0) | numerico}}
        </span>
      </div>
      <div class="col dato">
        <Strong class="title">Excedentes</Strong>
        <span class="value">
          $ {{(detallePagos.monto_excente != null ? detallePagos.monto_excente :0) | numerico}}
        </span>
      </div>
      <div class="col dato">
        <Strong class="title">Gasto de Ruta</Strong>
        <span class="value">
          $ {{(detallePagos.monto_cargo_ruta != null ? detallePagos.monto_cargo_ruta :0) | numerico}}
        </span>
      </div>
    </div>
  </div>
</div>
<!--
<app-liquidacion-recorrido-tabs-forma-pago (onAceptar)="onAceptarFormaPago($event)">
</app-liquidacion-recorrido-tabs-forma-pago>
app-modal-control-efectivo
-->


<ng-container *ngIf="listaRecorridos?.length > 0 && !operationCompleted">
  <div class="card mb-2 wow">
    <div class="row d-sm-flex p-1 justify-content-between">
      <div class="col-sm-4 d-sm-flex justify-content-start">
        <button mdbBtn size="sm" type="button" color="warning" mdbWavesEffect class="btn btn-sm"
          (click)="mostrarModalEliminacion()">
          Eliminar abono
        </button>
      </div>
      <div class="col-sm-8 d-sm-flex justify-content-end">
        <button mdbBtn size="sm" type="button" color="secondary" mdbWavesEffect class="btn btn-sm"
          (click)="showModalPago()">
          Pagar
        </button>
        <!-- <button mdbBtn size="sm" type="button" color="success" mdbWavesEffect class="btn btn-sm"
          (click)="cerrarLiquidacion()">
          Cerrar liquidación de recorrido
        </button> -->
        <app-api-button (click2)="cerrarLiquidacion()" [processing]="processing"> Cerrar liquidación de recorrido
        </app-api-button>
      </div>
    </div>
  </div>
</ng-container>

<!-- MODAL ELIMINAR ABONOS -->
<div mdbModal #eliminarAbonos="mdb-modal" class="modal fade" id="pagos" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true, keyboard: false }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Confirmación
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="eliminarAbonos.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <h6>¿Desea continuar?</h6>
        <h6>Se borrarán TODOS los abonos asociados al cliente del documento seleccionado.</h6>
      </div>
      <div class="modal-footer justify-content-end">
        <div class="row d-sm-flex justify-content-between">
          <div class="col-sm">
            <button mdbBtn type="button" color="danger" mdbWavesEffect class="btn" (click)="eliminarAbonos.hide()">
              Cancelar
            </button>
          </div>
          <div class="col-sm">
            <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="eliminarPagos()">
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL verAbonos -->
<div mdbModal #verAbonos="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="max-width: 50%;" role="document">
    <div class="modal-content" *ngIf="currentRecorrido">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Abonos del documento Nro. {{currentRecorrido.cabecera.folio}}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="verAbonos.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body table-responsive">
        <table class="table table-striped table-hover table-sm align-middle mt-1">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col">Tipo de pago</th>
              <th scope="col">Importe</th>
              <th scope="col">Nro. Cheque/Comprobante</th>
              <th scope="col">Banco/Vendedor</th>
              <th scope="col">Nro. Cuenta</th>
              <th scope="col">Fecha Cheque/Transferencia</th>
              <th scope="col">Excedente a Pago a Cuenta</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let detalle of currentRecorrido.detalleAbonos">
              <td>
                <span *ngIf="detalle.permite_borrar === false" [ngStyle]="{ 'color': 'red' }">
                  {{detalle.tipo_pago}}</span>
                <span *ngIf="detalle.permite_borrar === true" [ngStyle]="{color: 'black'}"> {{detalle.tipo_pago}}</span>
              </td>
              <td>
                <span *ngIf="detalle.permite_borrar === false" [ngStyle]="{ 'color': 'red' }">$ {{detalle.monto_pagado |
                  numerico}}</span>
                <span *ngIf="detalle.permite_borrar === true" [ngStyle]="{color: 'black'}">$ {{detalle.monto_pagado |
                  numerico}}</span>
              </td>
              <td>
                <span *ngIf="detalle.permite_borrar === false" [ngStyle]="{ 'color': 'red' }">
                  <span *ngIf="detalle.nro_comprobante_transferencia">{{detalle.nro_comprobante_transferencia}}</span>
                  <span *ngIf="detalle.numero_documento">{{detalle.numero_documento}}</span>
                </span>
                <span *ngIf="detalle.permite_borrar === true" [ngStyle]="{color: 'black'}">
                  <span *ngIf="detalle.nro_comprobante_transferencia">{{detalle.nro_comprobante_transferencia}}</span>
                  <span *ngIf="detalle.numero_documento">{{detalle.numero_documento}}</span>
                </span>
              </td>
              <td>
                <span *ngIf="detalle.permite_borrar === false" [ngStyle]="{ 'color': 'red' }">
                  {{detalle.banco_nombre}}</span>
                <span *ngIf="detalle.permite_borrar === true" [ngStyle]="{color: 'black'}">
                  {{detalle.banco_nombre}}</span>
              </td>
              <td><span *ngIf="detalle.numero_cuenta">
                  <span *ngIf="detalle.permite_borrar === false" [ngStyle]="{ 'color': 'red' }">
                    {{detalle.numero_cuenta}}</span>
                  <span *ngIf="detalle.permite_borrar === true" [ngStyle]="{color: 'black'}">
                    {{detalle.numero_cuenta}}</span>

                </span></td>
              <td>
                <span *ngIf="detalle.permite_borrar === false" [ngStyle]="{ 'color': 'red' }"> {{detalle.fecha_documento
                  | fecha}}</span>
                <span *ngIf="detalle.permite_borrar === true" [ngStyle]="{color: 'black'}"> {{detalle.fecha_documento |
                  fecha}}</span>
              </td>
              <td align="right">
                <span *ngIf="detalle.permite_borrar === false" [ngStyle]="{ 'color': 'red' }">$ {{detalle.pago_cuenta |
                  numerico}}</span>
                <span *ngIf="detalle.permite_borrar === true" [ngStyle]="{color: 'black'}">$ {{detalle.pago_cuenta |
                  numerico}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" size="sm" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="verAbonos.hide()" mdbWavesEffect>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal pago -->
<div mdbModal #pagar="mdb-modal" class="modal fade" id="pagos" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true, keyboard: false }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4>Pago</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalPagos()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="col d-flex md-form">
        <h6 style="display: contents;" *ngIf="sonMismoCliente">
          Cond. pago: {{ condicion_pago }}
        </h6>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-sm">
              <h6>Monto a declarar:</h6>
            </div>
            <div class="col-sm">
              <h6>$ {{montosPago[0] | numerico}}</h6>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <h6>Abonos:</h6>
            </div>
            <div class="col-sm">
              <h6>$ {{montosPago[1] | numerico}}</h6>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <h6>Falta por declarar:</h6>
            </div>
            <div class="col-sm">
              <h6>$ {{montosPago[2] | numerico}}</h6>
            </div>
          </div>
          <div class="row">
            <div class="col-sm d-sm-flex align-self-center">
              <h6>Tipo de pago:</h6>
            </div>
            <div class="col-sm">
              <select *ngIf="sonMismoCliente" id="inputTipoPago" class="form-control form-control2"
                (change)="onTipoPagoSelect($event.target.value)" [disabled]="montosPago[2] < 0">
                <option selected value="0">Efectivo</option>
                <option value="1">Cheque</option>
                <option value="2">Cobro vendedor</option>
                <option value="3">Transferencia</option>
              </select>
              <select *ngIf="!sonMismoCliente" id="inputTipoPago" class="form-control form-control2"
                (change)="onTipoPagoSelect($event.target.value)" [disabled]="montosPago[2] < 0">
                <option selected value="0">Efectivo</option>
                <option value="2">Cobro vendedor</option>
              </select>
            </div>
          </div>
          <!-- TIPOS DE PAGO -->
          <div class="container p-0">
            <!-- EFECTIVO -->
            <form *ngIf="mostrarTipoPago[0]" autocomplete="off" [formGroup]='formEfectivo'>
              <div class="row mt-3">
                <div class="col-sm-6">
                  <div class="md-form">
                    <input value="" type="text" id="montoEfectivo" class="form-control" formControlName="montoEfectivo"
                      placeholder="Monto" required #montoEfectivo onlyNumbers />
                    <label for="montoEfectivo">Monto:</label>
                  </div>
                </div>
                <div class="col-sm d-sm-flex align-items-center">
                  <mdb-checkbox formControlName="abonarTotalSaldoPendiente"
                    (change)="abonarTotalSaldoPendiente($event, 0)">
                    Abonar total saldo pendiente
                  </mdb-checkbox>
                </div>
              </div>
              <div class="row d-sm-flex justify-content-end">
                <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="agregarPago(0)"
                  [disabled]="montosPago[2] < 0">
                  Agregar
                </button>
              </div>
              <div class="row d-sm-flex justify-content-end" *ngIf="
                                    formEfectivo.get('montoEfectivo').invalid &&
                                    (formEfectivo.get('montoEfectivo').dirty ||
                                    formEfectivo.get('montoEfectivo').touched)
                                    ">
                <span *ngIf="formEfectivo.get('montoEfectivo').hasError('required')" class="span-error">
                  Datos no válidos, verifique los campos.
                </span>
              </div>
            </form>

            <!-- CHEQUE -->
            <form *ngIf="mostrarTipoPago[1]" autocomplete="off" [formGroup]='formCheque'>
              <div class="row mt-3">
                <div class="col-sm-4">
                  <div class="md-form">
                    <input value="" type="text" id="nroDocumento" class="form-control" formControlName="nroDocumento"
                      placeholder="Nro. documento" required #nroDocumento onlyNumbers />
                    <label for="nroDocumento">Nro. documento:</label>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="md-form">
                    <input value="" type="text" id="montoCheque" class="form-control" formControlName="montoCheque"
                      placeholder="Monto" required #montoCheque onlyNumbers />
                    <label for="montoCheque">Monto:</label>
                  </div>
                </div>
                <div class="col-sm d-sm-flex align-items-center">
                  <mdb-checkbox formControlName="abonarTotalSaldoPendiente"
                    (change)="abonarTotalSaldoPendiente($event, 1)">
                    Abonar total saldo pendiente
                  </mdb-checkbox>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm-4">
                  <div class="md-form">
                    <mdb-select label="Banco" [options]="optionsBancosTodos" placeholder="Banco" formControlName="banco"
                      [filterEnabled]="true"></mdb-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="md-form">
                    <input value="" type="text" id="nroCuenta" class="form-control" formControlName="nroCuenta"
                      placeholder="Nro. de cuenta" required #nroCuenta />
                    <label for="nroCuenta">Nro. de cuenta:</label>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="md-form">
                    <mdb-date-picker #dpFechaTransferencia [inline]="true" name="fecha" [placeholder]="'Fecha'"
                      formControlName="fecha" required>
                    </mdb-date-picker>
                    <label for="FechaVencimiento">Fecha de vencimiento:</label>
                  </div>
                </div>
              </div>
              <div class="row d-sm-flex justify-content-end">
                <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="agregarPago(1)"
                  [disabled]="montosPago[2] < 0">
                  Agregar
                </button>
              </div>
              <div class="row d-sm-flex justify-content-end" *ngIf="formCheque.get('montoCheque').touched || formCheque.get('nroDocumento').touched ||
                                       formCheque.get('banco').touched || formCheque.get('nroCuenta').touched ||
                                       formCheque.get('fecha').touched">
                <span class="span-error" *ngIf="formCheque.get('montoCheque').hasError('required') || formCheque.get('nroDocumento').hasError('required') ||
                                             formCheque.get('banco').hasError('required') || formCheque.get('nroCuenta').hasError('required') ||
                                             formCheque.get('fecha').hasError('required')">
                  Datos no válidos, verifique los campos.
                </span>
              </div>
            </form>

            <!-- Cobro vendedor -->
            <form *ngIf="mostrarTipoPago[2]" autocomplete="off" [formGroup]='formCobroVendedor'>
              <div class="row mt-3" style="display: none;">
                <div class="col-sm d-sm-flex align-items-center">
                  <mdb-checkbox formControlName="pagadoVendedor">Este documento sera pagado al
                    vendedor...</mdb-checkbox>
                </div>
              </div>
              <div class="row d-sm-flex justify-content-end">
                <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="agregarPago(2)"
                  [disabled]="montosPago[2] < 0">
                  Agregar
                </button>
              </div>
            </form>

            <!-- Transferencia -->
            <form *ngIf="mostrarTipoPago[3]" autocomplete="off" [formGroup]='formTransferencia'>
              <div class="row mt-3">
                <div class="col-sm-4">
                  <div class="md-form">
                    <input value="" type="text" id="nroComprobante" class="form-control"
                      formControlName="nroComprobante" placeholder="Nro. documento" #nroComprobante />
                    <label for="nroComprobante">Nro. comprobante:</label>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="md-form">
                    <input value="" type="text" id="montoTransferencia" class="form-control"
                      formControlName="montoTransferencia" placeholder="Monto" required #montoTransferencia />
                    <label for="montoTransferencia">Monto:</label>
                  </div>
                </div>
                <div class="col-sm d-sm-flex align-items-center">
                  <mdb-checkbox formControlName="abonarTotalSaldoPendiente"
                    (change)="abonarTotalSaldoPendiente($event, 3)">
                    Abonar total saldo pendiente
                  </mdb-checkbox>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm-4">
                  <div class="md-form">
                    <mdb-select label="Banco:" [options]="optionsBancosEmpresa" placeholder="Banco"
                      formControlName="banco" [filterEnabled]="true"></mdb-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="md-form">
                    <mdb-select label="Cuenta destino:" [options]="optionsCuentasBancosTransferencia"
                      placeholder="Cuenta destino" formControlName="cuentaDestino" [filterEnabled]="true"></mdb-select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="md-form">
                    <mdb-date-picker [inline]="true" name="fecha" [placeholder]="'Fecha'" formControlName="fecha"
                      required>
                    </mdb-date-picker>
                  </div>
                </div>
              </div>
              <div class="row d-sm-flex justify-content-end">
                <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect (click)="agregarPago(3)"
                  [disabled]="montosPago[2] < 0">
                  Agregar
                </button>
              </div>
              <div class="row d-sm-flex justify-content-end" *ngIf="formTransferencia.get('montoTransferencia').touched || formTransferencia.get('nroComprobante').touched ||
                                    formTransferencia.get('banco').touched || formTransferencia.get('cuentaDestino').touched ||
                                    formTransferencia.get('fecha').touched">
                <span class="span-error" *ngIf="formTransferencia.get('montoTransferencia').hasError('required') || formTransferencia.get('nroComprobante').hasError('required') ||
                                        formTransferencia.get('banco').hasError('required') || formTransferencia.get('cuentaDestino').hasError('required') ||
                                        formTransferencia.get('fecha').hasError('required')">
                  Datos no válidos, verifique los campos.
                </span>
              </div>
            </form>
          </div>

          <!-- TABLA PAGOS -->
          <div *ngIf="listaPagos.length > 0" class="row mt-3 table-responsive">
            <table class="table table-striped table-hover table-sm align-middle mt-1">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Tipo de pago</th>
                  <th scope="col">Importe</th>
                  <th scope="col">Nro. Cheque/Comprobante</th>
                  <th scope="col">Banco/Vendedor</th>
                  <th scope="col">Nro. Cuenta</th>
                  <th scope="col">Fecha Cheque/Transferencia</th>
                </tr>
              </thead>
              <tbody style="text-align: center;">
                <tr *ngFor="let pago of listaPagos">
                  <td><i class="fas fa-trash-alt" (click)="borrarPago(pago.idPago)"></i></td>
                  <td>{{pago.tipoPago}}</td>
                  <td>${{pago.monto_pago | numerico}}</td>
                  <td>{{pago.nroChequeComprobante}}</td>
                  <td>{{pago.banco_nombre}}</td>
                  <td>{{pago.numero_cuenta}}</td>
                  <td>{{pago.fecha_documento | fecha}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row mt-3 d-sm-flex justify-content-end">
            <div class="row d-sm-flex justify-content-between">

              <button mdbBtn type="button" size="sm" color="default" mdbWavesEffect class="btn btn-sm"
                (click)="closeModalPagos()">
                Cerrar
              </button>

              <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
                (click)="crearPago()" [disabled]="montosPago[2] > 0">
                <div class="spinner-border spinner-border-sm" *ngIf="btnPagar === true">
                  <mdb-spinner spinnerColor="transparent"></mdb-spinner>
                </div>
                Pagar
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarRecorrido -->
<!-- <app-devolucion-mercaderia-modal-seleccionar-recorrido (onSelect)="onRecorridoSeleccionado($event)"
    (onNotFound)="onNotFoundRecorrido()">
</app-devolucion-mercaderia-modal-seleccionar-recorrido> -->

<!-- <app-modal-seleccionar-recorrido-liquidacion (onSelect)="onRecorridoSeleccionado($event)"
(onNotFound)="onNotFoundRecorrido()">
</app-modal-seleccionar-recorrido-liquidacion> -->


<app-modal-info></app-modal-info>
<app-modal-confirm></app-modal-confirm>
<app-modal-liquidacion-control-efectivo
  (onControlEfectivoRealizado)="controlEfectivoRealizado()"></app-modal-liquidacion-control-efectivo>